import axios from 'axios'
import config from '../config'

const Order = {
    state: {
        orderList: [],
        orderExcel: [],
        orderChangeExcel: [],
        orderReturnExcel: [],
        orderDetail: [],
        orderChangeList: [],
        orderChangeDetail: [],
        orderReturnList: [],
        orderReturnDetail: [],
        orderReturnLog: [],
        orderChangeLog: [],
        userPerformance: [],
        shopPerformance: [],
        error: false,
        msg: ''
    },
    mutations: {
        OrderList: (state, orderList) => state.orderList = orderList,
        OrderExcel: (state, orderExcel) => state.orderExcel = orderExcel,
        OrderChangeExcel: (state, orderChangeExcel) => state.orderChangeExcel = orderChangeExcel,
        OrderReturnExcel: (state, orderReturnExcel) => state.orderReturnExcel = orderReturnExcel,
        OrderDetail: (state, orderDetail) => state.orderDetail = orderDetail,
        OrderChangeList: (state, orderChangeList) => state.orderChangeList = orderChangeList,
        OrderChangeDetail: (state, orderChangeDetail) => state.orderChangeDetail = orderChangeDetail,
        OrderReturnList: (state, orderReturnList) => state.orderReturnList = orderReturnList,
        OrderReturnDetail: (state, orderReturnDetail) => state.orderReturnDetail = orderReturnDetail,
        OrderReturnLog: (state, orderReturnLog) => state.orderReturnLog = orderReturnLog,
        OrderChangeLog: (state, orderChangeLog) => state.orderChangeLog = orderChangeLog,
        OrderUserPerformance: (state, userPerformance) => state.userPerformance = userPerformance,
        OrderShopPerformance: (state, shopPerformance) => state.shopPerformance = shopPerformance,
        ERROR: (state, error) => state.error = error,
        MSG: (state, msg) => state.msg = msg
    },
    actions: {
        async fetchOrderList({commit}, data){
            await axios({
                method:'post',
                url: config.LOAD_ORDER_LIST,
                data: data
            })
            .then((result) => {
                commit('OrderList', result.data.orders)
                commit('ERROR', result.data.error)
                commit('MSG', result.data.msg)
            }).catch((err) => {
                console.log(err);
            });
        },
        async fetchOrderDetail({commit}, data){
            await axios({
                method:'post',
                url: config.LOAD_ORDER_DETAIL,
                data: data
            })
            .then((result) => {
                commit('OrderDetail', result.data.order)
                commit('OrderUserPerformance', result.data.userperformance)
                commit('OrderShopPerformance', result.data.shopPerformance)
                commit('ERROR', result.data.error)
                commit('MSG', result.data.msg)
            }).catch((err) => {
                console.log(err);                
            });
        },
        async fetchChreList({commit}, data){
            await axios({
                method:'post',
                url: config.LOAD_ORDER_DETAIL,
                data: data
            })
            .then((result) => {
                commit('OrderReturnLog', result.data.returnLog)
                commit('OrderChangeLog', result.data.changeLog)
                commit('ERROR', result.data.error)
                commit('MSG', result.data.msg)
            }).catch((err) => {
                console.log(err);                
            });
        },
        async chFetchChreList({commit}, data){
            await axios({
                method:'post',
                url: config.LOAD_ORDER_CHANGE_DETAIL,
                data: data
            })
            .then((result) => {
                console.log(result)
                commit('OrderReturnLog', result.data.returnLog)
                commit('OrderChangeLog', result.data.changeLog)
                commit('ERROR', result.data.error)
                commit('MSG', result.data.msg)
            }).catch((err) => {
                console.log(err);                
            });
        },
        async reFetchChreList({commit}, data){
            await axios({
                method:'post',
                url: config.LOAD_ORDER_RETURN_DETAIL,
                data: data
            })
            .then((result) => {
                console.log(result)
                commit('OrderReturnLog', result.data.returnLog)
                commit('OrderChangeLog', result.data.changeLog)
                commit('ERROR', result.data.error)
                commit('MSG', result.data.msg)
            }).catch((err) => {
                console.log(err);                
            });
        },
        async fetchOrderChangeList({commit}, data){
            await axios({
                method:'post',
                url: config.LOAD_ORDER_CHANGE_LIST,
                data: data
            })
            .then((result) => {
                commit('OrderChangeList', result.data.result)
                commit('ERROR', result.data.error)
                commit('MSG', result.data.msg)
            }).catch((err) => {
                console.log(err);
            });
        },
        async fetchOrderReturnList({commit}, data){
            await axios({
                method:'post',
                url: config.LOAD_ORDER_RETURN_LIST,
                data: data
            })
            .then((result) => {
                commit('OrderReturnList', result.data.result)
                commit('ERROR', result.data.error)
                commit('MSG', result.data.msg)
            }).catch((err) => {
                console.log(err);
            });
        },
        async fetchOrderChangeDetail({commit}, data){
            await axios({
                method:'post',
                url: config.LOAD_ORDER_CHANGE_DETAIL,
                data: data
            })
            .then((result) => {
                commit('OrderChangeDetail', result.data.order)
                commit('OrderUserPerformance', result.data.userperformance)
                commit('OrderShopPerformance', result.data.shopPerformance)
                commit('ERROR', result.data.error)
                commit('MSG', result.data.msg)
            }).catch((err) => {
                console.log(err);
            });
        },

        async fetchOrderReturnDetail({commit}, data){
            await axios({
                method:'post',
                url: config.LOAD_ORDER_RETURN_DETAIL,
                data: data
            })
            .then((result) => {
                console.log(result);
                commit('OrderReturnDetail', result.data.order)
                commit('OrderUserPerformance', result.data.userperformance)
                commit('OrderShopPerformance', result.data.shopPerformance)
                commit('ERROR', result.data.error)
                commit('MSG', result.data.msg)
            }).catch((err) => {
                console.log(err);
            });
        },
       
            async fetchOrderExcel({commit}, data){
                await axios({
                    method:'post',
                    url: config.LOAD_ORDER_EXCEL,
                    data: data
                })
                .then((result) => {
                    commit('OrderExcel', result.data.excel)
                    commit('ERROR', result.data.error)
                    commit('MSG', result.data.msg)
                }).catch((err) => {
                    console.log(err);
                });
            },
            async fetchOrderChangeExcel({commit}, data){
                await axios({
                    method:'post',
                    url: config.LOAD_ORDER_CHANGE_EXCEL,
                    data: data
                })
                .then((result) => {
                    commit('OrderChangeExcel', result.data.excel)
                    commit('ERROR', result.data.error)
                    commit('MSG', result.data.msg)
                }).catch((err) => {
                    console.log(err);
                });
            },
            async fetchOrderReturnExcel({commit}, data){
                await axios({
                    method:'post',
                    url: config.LOAD_ORDER_RETURN_EXCEL,
                    data: data
                })
                .then((result) => {
                    commit('OrderReturnExcel', result.data.excel)
                    commit('ERROR', result.data.error)
                    commit('MSG', result.data.msg)
                }).catch((err) => {
                    console.log(err);
                });
            },
    },

    
    getters: {
        getOrderList: state => state.orderList,
        getOrderExcel: state => state.orderExcel,
        getOrderChangeExcel: state => state.orderChangeExcel,
        getOrderReturnExcel: state => state.orderReturnExcel,
        getOrderDetail: state => state.orderDetail,
        getOrderChangeList: state => state.orderChangeList,
        getOrderReturnList: state => state.orderReturnList,
        getOrderChangeDetail: state => state.orderChangeDetail,
        getOrderReturnDetail: state => state.orderReturnDetail,
        getUserPerformance: state => state.userPerformance,
        getShopPerformance: state => state.shopPerformance,
        getOrderReturnLog: state => state.orderReturnLog,
        getOrderChangeLog: state => state.orderChangeLog,
        getOrderError: state => state.error,
        getOrderMsg: state => state.msg
    },
}

export default Order;